import { FetchStatusType } from '../../../types/interfaces';

export function SkeletonList({ status }: { status: FetchStatusType }) {
  if (status !== 'loading') return null;
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse bg-gray-200 rounded-[15px] mb-5 w-full min-h-[200px]"
        />
      ))}
    </>
  );
}
